import { render, staticRenderFns } from "./le-card.vue?vue&type=template&id=33e2b1b2&scoped=true&"
import script from "./le-card.vue?vue&type=script&lang=js&"
export * from "./le-card.vue?vue&type=script&lang=js&"
import style0 from "./le-card.vue?vue&type=style&index=0&id=33e2b1b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2b1b2",
  null
  
)

export default component.exports